import { render, staticRenderFns } from "./todel.vue?vue&type=template&id=d50aedae&scoped=true"
import script from "./todel.vue?vue&type=script&lang=js"
export * from "./todel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50aedae",
  null
  
)

export default component.exports